import React from "react";
import NavBar from "../../commonComponents/NavBar/NavBar";
import { Outlet } from "react-router-dom";

const MainLayout = () => {
  return (
    <>
      <NavBar />
      <div style={{ paddingTop: "20px" }}>
        {/* adjust 80px to your navbar height */}
        <Outlet />
      </div>
    </>
  );
};

export default MainLayout;
